import { render, staticRenderFns } from "./MasterMainteTab.vue?vue&type=template&id=d87229f4&"
import script from "./MasterMainteTab.vue?vue&type=script&lang=ts&"
export * from "./MasterMainteTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports